




















import { Component, Vue } from "vue-property-decorator";
import { EventBus } from "../event-bus";

@Component({
  components: {}
})
export default class Snackbar extends Vue {
  public snackbar = false;
  public text = "";
  public color = "";

  created() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    EventBus.$on("showSnackbar", (data: any) => {
      this.snackbar = false;
      this.text = data.text;
      this.color = data.color;
      EventBus.$emit("ReloadLogs", null);

      setTimeout(() => {
        this.snackbar = true;
      }, 1000);
    });
  }
}
